// extracted by mini-css-extract-plugin
module.exports = {"features":"features_features__3-43x","container":"features_container__6-fxC","feature":"features_feature__2dgdX"};